module.exports = __webpack_public_path__ + "public/img/ico-schematics-household-shadow.f62b909f.svg";